import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Version } from 'src/app/processes/_interfaces/version.interface';

@Component({
    selector: 'app-configure-threesixty-limit',
    templateUrl: './configure-threesixty-limit.component.html',
    styleUrls: ['./configure-threesixty-limit.component.scss'],
})
export class ConfigureThreesixtyLimitComponent implements OnInit {
    public formGroup: UntypedFormGroup;
    @Input() public version: Version;

    constructor(
        private _modalController: ModalController,
        private _formBuilder: UntypedFormBuilder) {
    }

    ngOnInit() {
        this.formGroup = this._createFormGroup();
    }

    private _createFormGroup() {
        const form = this._formBuilder.group({
            maxReviews: [this.version.threeSixtyEvaluationLimit, [Validators.required, Validators.min(1), Validators.max(100)]],
            evaluationTimespanInHours: [`${this.version.threeSixtyEvaluationTimespanInHours || ''}`, [Validators.required]],
        });
        return form;
    }

    public save() {
        if(this.formGroup.invalid) return;
        this.version.threeSixtyEvaluationLimit = this.formGroup.get('maxReviews').value;
        this.version.threeSixtyEvaluationTimespanInHours = Number(this.formGroup.get('evaluationTimespanInHours').value);
        this._modalController.dismiss(this.version);
    }

    public dismiss() {
        const hasNoValue = Number(this.version.threeSixtyEvaluationLimit || 0) === 0 || Number(this.version.threeSixtyEvaluationLimit || 0) === 0;
        if (hasNoValue)
            this.version.enableValuationLimit = false;
        this._modalController.dismiss(this.version);
    }

}
